import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackCloseDesktopListing, trackOpenDesktopListing } from './tracking';
import { closeDesktopListing } from '../../../common/actions/desktopListing/closeDesktopListing';
import { openDesktopListing } from '../../../common/actions/desktopListing/openDesktopListing';
import { selectIsDesktopListingVisible } from '../../../common/selectors/desktopListing';
import { TThunkDispatch } from '../../../common/types/redux';
import { ListingToggleButton } from '../../components/ListingToggleButton/ListingToggleButton';

export const ListingToggleButtonContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isVisible = useSelector(selectIsDesktopListingVisible);

  const handleClick = React.useCallback(() => {
    if (isVisible) {
      trackCloseDesktopListing();
      dispatch(closeDesktopListing());
    } else {
      trackOpenDesktopListing();
      dispatch(openDesktopListing());
    }
  }, [dispatch, isVisible]);

  return <ListingToggleButton isListingVisible={isVisible} onClick={handleClick} />;
};
